<div class="wrapper" data-testid="reset-password-container">
  <!-- Header -->
  <div class="header">
    <img class="evnavi-logo" src="assets/icons/light/logo/ev_navigation_logo.png" alt="EVNavigation Logo" />
  </div>

  <!-- Body -->
  <div id="reset-body">

    <!-- SUCCESS -->
    @if (viewState === 'success') {
      <div id="bodycontent-start">
        <p class="smaller" [innerHTML]="languageJSON.ResetPassword_SuccesText1"></p>
        <p class="smaller" [innerHTML]="successText2"></p>
      </div>
    }

    <!-- ERROR -->
    @if (viewState === 'error') {
      <div id="bodycontent-start">
        <p class="smaller" [innerHTML]="languageJSON.ResetPassword_ErrorText1"></p>
        <p class="smaller" [innerHTML]="languageJSON.ResetPassword_ErrorText2"></p>
      </div>
    }

    <!-- FORM -->
    @if (viewState === 'form') {
      <ng-container class="form-container">
        <div id="bodycontent-start">
          <p class="smaller" [innerHTML]="languageJSON.ResetPassword_FormText1"></p>
          <p class="smaller" [innerHTML]="languageJSON.ResetPassword_FormText2"></p>
          @if (!loading) {
            <form [formGroup]="form" (ngSubmit)="onSubmit()" id="form-form" data-testid="reset-password-form" novalidate>
              <p class="form-info-text" [innerHTML]="languageJSON.ResetPassword_FormText3"></p>
              <label for="form-new-password">{{ languageJSON.Global_Password}}</label>
              <input id="form-new-password" name="form-new-password" data-testid="reset-password-password-input" formControlName="password"
                [type]="showPassword ? 'text' : 'password'" [attr.pattern]="passwordPattern.source" required />
                <div id="password-eye" data-testid="reset-password-password-toggle-btn" [ngClass]="showPassword ? 'password-eye-off' : 'password-eye-on'"
                (click)="togglePassword()" role="button" tabindex="0" aria-label="Toggle password visibility"></div>
                @if (password?.invalid && password.touched) {
                  <h6 class="invalid">
                  {{ languageJSON.AccountDialog_Password_Invalid }}</h6>
                }
                <label for="form-new-password-confirmation">{{ languageJSON.Global_PasswordConfirmation }}</label>
                <input id="form-new-password-confirmation" name="form-new-password-confirmation"
                  data-testid="reset-password-password-confirmation-input"
                  formControlName="password_confirmation" [type]="showPasswordConfirmation ? 'text' : 'password'"
                  [attr.pattern]="passwordPattern.source" required />
                  <div id="password-eye" data-testid="reset-password-password-confirmation-toggle-btn" [ngClass]="showPasswordConfirmation ? 'password-eye-off' : 'password-eye-on'"
                    (click)="togglePasswordConfirmation()" role="button" tabindex="0" aria-label="Toggle password visibility">
                  </div>
                  <span class="error-container">
                    @if (password_confirmation?.invalid && password_confirmation.touched) {
                      <h6 class="invalid">
                      {{ languageJSON.AccountDialog_Password_Invalid }}</h6>
                    }
                    @if (registerPasswordsMatch) {
                      <h6 class="invalid">
                        {{ languageJSON.AccountDialog_Password_NotMatch }}
                      </h6>
                    }
                  </span>
                  <button type="submit" class="button text-size-corr" [class.disabled]="form.invalid || loading"
                    [disabled]="form.invalid || loading" id="form-submit-btn" data-testid="reset-password-submit-btn">
                    {{ languageJSON.AccountDialog_ChangePassword }}
                  </button>
                </form>
              }
              @if (loading) {
                <mat-spinner id="loading-spinner" strokeWidth="6"></mat-spinner>
              }
            </div>
          </ng-container>
        }
      </div>

      <!-- Footer -->
      <div class="footer">
        <img src="assets/icons/default/ui/floating_car_icon.png" alt="" class="floatingcar" />

        <a class="social_icons" data-testid="reset-password-app-store-link" href="https://apps.apple.com/app/ev-navigation/id1494131819">
          <img class="app-store-icon" src="assets/icons/default/social/en/app_store_button.svg"
            alt="Get in on Apple store" />
          </a>

          <a class="social_icons" data-testid="reset-password-google-play-link" href="https://play.google.com/store/apps/details?id=com.gpstuner.evnavigation">
            <img class="google-play-icon" src="assets/icons/default/social/en/google_play_button.svg"
              alt="Get it on Google Play" />
            </a>

            <div>
              <img src="/assets/icons/light/logo/gpst_logo.svg" alt="GPS Tuner Systems logo" class="gpst-logo" />
            </div>

            Copyright © 2020-2026 GPS TUNER SYSTEMS KFT. - All rights reserved.
          </div>
        </div>